import React, { useState } from "react";
import styled from "styled-components";
import moment from "moment"
import { Button } from "react-bootstrap";
import { useDispatch } from 'react-redux';
import { loadActiveUsersBetweenDates, loadActiveUsersBetweenDates2 } from "../../app/actions"

const DatePicker = styled.div`
  max-width: 280px;
  position: absolute;
  background-color: white;
  box-shadow: 0px 1px 4px #c5c5c5;
  -webkit-box-shadow: 0px 1px 4px #c5c5c5;
  -moz-box-shadow: 0px 1px 4px #c5c5c5;
  margin-bottom: 1em;
  border-radius: 4px;
`
const YearContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-weight: bold;
  height: 80px;
`
const Year = styled.div`
`
const ChangeYearBtn = styled.div`
  cursor: pointer;
`
const MonthsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`
const Month = styled.div`
  width: 33%;
  height: 40px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all ease 0.2s;

  &:hover,
  &:focus,
  &:active {
    background-color: #232b41;
    color: white;
  }
`
const FooterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 10px;
  margin-top: 20px;
  border-top: 1px solid lightgrey;
`
const SearchBtn = styled(Button)`
`
const CloseBtn = styled(Button)`
`

export const MonthPicker = ({ setFromDate, setToDate, setToggleMonthPicker }) => {

    //Dispatch
    const dispatch = useDispatch();

  //If desktop
  const [year, setYear] = useState(moment().year())
  const [monthIndex, setMonthIndex] = useState("")

  const nextYear = () => {
      setYear(prev => prev + 1)
  }
  const prevYear = () => {
    setYear(prev => prev - 1)
  }
  const pickMonth = (monthIndex) => {
    setMonthIndex(monthIndex)
  }
  const handleSubmit = () => {
    let from = moment([year, monthIndex]).subtract(1, 'year').add(1, 'month').startOf("month").format("YYYY-MM-DD")
    let to = moment([year, monthIndex]).endOf("month").format("YYYY-MM-DD")
    setFromDate(from)
    setToDate(to)
    dispatch(loadActiveUsersBetweenDates(from, to))
    dispatch(loadActiveUsersBetweenDates2(moment(from).subtract(1, 'year').format("YYYY-MM-DD"), moment(to).subtract(1, 'year').format("YYYY-MM-DD")))
    setToggleMonthPicker(false)
  }

  return (
      <DatePicker>
          <YearContainer>
            <ChangeYearBtn onClick={prevYear}><i className="fa fa-arrow-left"></i></ChangeYearBtn>
            <Year>{year}</Year>
            <ChangeYearBtn onClick={nextYear}><i className="fa fa-arrow-right"></i></ChangeYearBtn>
          </YearContainer>
          <MonthsContainer>
            <Month onClick={() => pickMonth(0)}>Jan</Month>
            <Month onClick={() => pickMonth(1)}>Feb</Month>
            <Month onClick={() => pickMonth(2)}>Mar</Month>
            <Month onClick={() => pickMonth(3)}>Apr</Month>
            <Month onClick={() => pickMonth(4)}>May</Month>
            <Month onClick={() => pickMonth(5)}>Jun</Month>
            <Month onClick={() => pickMonth(6)}>Jul</Month>
            <Month onClick={() => pickMonth(7)}>Aug</Month>
            <Month onClick={() => pickMonth(8)}>Sep</Month>
            <Month onClick={() => pickMonth(9)}>Oct</Month>
            <Month onClick={() => pickMonth(10)}>Nov</Month>
            <Month onClick={() => pickMonth(11)}>Dec</Month>
          </MonthsContainer>
          <FooterContainer>
            {monthIndex === "" ? 
              <CloseBtn onClick={() => setToggleMonthPicker(false)}>Close</CloseBtn> :
              <SearchBtn onClick={handleSubmit}>Ok</SearchBtn>
            }
          </FooterContainer>
      </DatePicker>
  );
};